import { HealthUnitRelationStruct } from "../../structs/integration-relation-config/health-unit-relation.struct";

export class HealthUnitRelationRequest {
    public healthUnitRelation: HealthUnitRelationStruct;
}